import AppSimpleBar from "components/AppSimpleBar";
import { Utils } from "helpers/utils";
import { useEffect, useRef, useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { MemberRole, TaskStatus, WpSliceData, WpStatus, WpTitle } from "../../../redux/workplace/wpTypes";
import { Link } from "react-router-dom";
import classnames from "classnames";
import LoadingIconWithText from "components/LoadingIconWithText";
import { useCursorPopup, useRedux } from "hooks";
import { createSelector } from "reselect";
import Loader from "components/Loader";
import { loadMoreTitleAction, loadSubTask, markAsRead, setActiveMemberrole, setActivePostId2, setDraftPost, sortTitlesTkLocal } from "../../../redux/workplace/wpActions";
import { TABS, WpModes, WpSortMode } from "../../../constants";
import { SKeys } from "const";
import { APIClient } from "../../../api/apiCore";
import * as urls from "../../../api/urls"
import { updateReadMultiApi } from "../../../api/wpapi";
import UserAvatar from "components/UserAvatar";

interface WorkplaceTitleProps {
  onToggleFilterPane: () => void;
  onClickSearch: () => void;
  onClickUnreadIcon: () => void;
  onClickTitle: (postId: string, postTitle: string, postAbbr: string, postFore: string, postBack: string, titleRow?: WpTitle) => void;
  wpMode: WpModes
}

const WorkplaceTitle = ({ onToggleFilterPane, onClickSearch, onClickUnreadIcon, onClickTitle, wpMode }: WorkplaceTitleProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.WpSlice,
    (state: any) => state.Layout,
    (wp: WpSliceData, layout) => ({
      // titles: wpMode == WpModes.Workplace ? wp.titles : wp.titlesTk,
      titlesWp: wp.titles,
      titlesTk: wp.titlesTk,
      titleLoading: wp.titleLoading,
      titleLoadingMore: wpMode == WpModes.Workplace ? wp.titleLoadingMoreWp : wp.titleLoadingMoreTk,
      titleHasMore: wpMode == WpModes.Workplace ? wp.titleHasMoreWp : wp.titleHasMoreTk,
      activePostId: wp.activePostInfo.postId, // wp.activePostId,
      activePostWpMode: wp.activePostInfo.wpMode,
      activeMemberRole: wpMode == WpModes.Workplace ? wp.activeMemberRole : wp.activeMemberRoleTk,
      roleUnread: wp.roleUnread,
      isInFrame: layout.isInFrame,
      titleFromTaskDashboard: wp.titleFromTaskDashboard
    })
  );
  const {/* titles,*/ titlesWp, titlesTk, titleLoading, titleLoadingMore, titleHasMore, activePostId, activePostWpMode, activeMemberRole, roleUnread, isInFrame, titleFromTaskDashboard } = useAppSelector(storeData);

  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());
  const isSelectMode = selectedIds.size > 0;

  const [isSortDropdownOpen, setIsSortDropdownOpen] = useState<boolean>(false);
  const [sortMode, setSortMode] = useState<WpSortMode>(() => Utils.Conf_WorkPlaceSortMode(wpMode));
  useEffect(() => {
    setSortMode(Utils.Conf_WorkPlaceSortMode(wpMode));
  }, [wpMode]);

  const onChangeSortMode = (mode: WpSortMode) => {
    if (mode == sortMode) return;
    setSortMode(mode);
    Utils.Conf_WorkPlaceSortMode(wpMode, mode);
    if (wpMode == WpModes.Task && titleFromTaskDashboard) {
      dispatch(sortTitlesTkLocal(mode)); // dashboard view is a fixed filtered set - just re-sort it client-side, no backend refetch
    } else {
      onClickSearch(); // reload from backend sorted by the newly chosen mode
    }
  }
  const totalUnread =
    wpMode == WpModes.Workplace
      ? roleUnread.unreadFlag + roleUnread.unreadFollower + roleUnread.unreadMyPost + roleUnread.unreadOwner + roleUnread.unreadTagMe + roleUnread.unreadOrganize + roleUnread.unreadPersonFollow + roleUnread.unreadObserver
      : roleUnread.taskUnreadMine + roleUnread.taskUnreadAssigner + roleUnread.taskUnreadRequestBy + roleUnread.taskUnreadFlag + roleUnread.taskUnreadRelated + roleUnread.taskUnreadObserver;
  // console.log('roleUnread:', roleUnread);
  // useEffect(() => { console.log('isDropdownOpen:' + isDropdownOpen); }, [isDropdownOpen]);
  const getMemberRoleFromStorage = () => {
    return Utils.GetMemberRoleFromStorage(wpMode);
  }
  // const [selMemberRole, setSelMemberRole] = useState<MemberRole>(getMemberRoleFromStorage());
  const [selMemberRoleText, setSelMemberRoleText] = useState<string>("");
  useEffect(() => {
    // setSelMemberRoleText(/*Utils.GetMemberRoleIcon(selMemberRole) + */Utils.GetMemberRoleText(activeMemberRole));
    const feedTitle = Utils.GetMemberRoleIcon(wpMode, activeMemberRole) + " " + Utils.GetMemberRoleText(wpMode, activeMemberRole);
    // console.log('feedTitle of ' + activeMemberRole + ' = ' + feedTitle);
    setSelMemberRoleText(feedTitle);
  }, [activeMemberRole]);

  const fnGetTotalUnreadOfRole = () => {
    if (wpMode == WpModes.Workplace) {
      return activeMemberRole === MemberRole.All ? totalUnread :
        activeMemberRole === MemberRole.Flag ? roleUnread.unreadFlag :
          activeMemberRole === MemberRole.Follower ? roleUnread.unreadFollower :
            activeMemberRole === MemberRole.Observer ? roleUnread.unreadObserver :
              activeMemberRole === MemberRole.MyPost ? roleUnread.unreadMyPost :
                activeMemberRole === MemberRole.Organize ? roleUnread.unreadOrganize :
                  activeMemberRole === MemberRole.Owner ? roleUnread.unreadOwner :
                    activeMemberRole === MemberRole.PersonFollow ? roleUnread.unreadPersonFollow :
                      activeMemberRole === MemberRole.TagMe ? roleUnread.unreadTagMe : 0;
    } else if (wpMode == WpModes.Task) {
      return activeMemberRole === MemberRole.All ? totalUnread :
        activeMemberRole === MemberRole.TaskMine ? roleUnread.taskUnreadMine :
          activeMemberRole === MemberRole.TaskAssigner ? roleUnread.taskUnreadAssigner :
            activeMemberRole === MemberRole.TaskReqBy ? roleUnread.taskUnreadRequestBy :
              activeMemberRole === MemberRole.Flag ? roleUnread.taskUnreadFlag :
                activeMemberRole === MemberRole.TaskRelated ? roleUnread.taskUnreadRelated :
                  activeMemberRole === MemberRole.Observer ? roleUnread.taskUnreadObserver : 0;
    }

    return 0;
  }

  const totalUnreadOfRole = fnGetTotalUnreadOfRole() ?? 0;


  const css_unread = localStorage.getItem("lm") == "dark" ? "badge-soft-dark" : "badge-soft-light";

  const clearActivePostOnTitleChange = (modeChange: WpModes, newTitles: WpTitle[], titleChanged: string) => {
    // if (wpMode == WpModes.Task) {
    //   console.log('clearActivePostOnTitleChange:', {
    //     isInFrame, wpMode, modeChange, activePostWpMode, activePostId
    //     , localWpId: localStorage.getItem(SKeys.RedirectWpId), foundInTitle: newTitles.some(t => t.postId == activePostId)
    //   });
    // }
    if (!isInFrame && wpMode == modeChange && activePostWpMode == modeChange) { // 20250716 don't set active post to nothing if run in frame, because run in frame some time direct show post id content
      if (activePostId) {
        //const haveActivePost = newTitles.some(t => t.postId == activePostId);
        // Scoped by wpMode - a Task redirect's flag must not protect a Workplace active post (and
        // vice versa), otherwise the wrong mode's title load could hold this open indefinitely.
        const haveActivePost = Utils.GetRedirectPostId(modeChange) != null || newTitles.some(t => t.postId == activePostId); // 20260114 add check redicet post id
        // console.log('Title change:', { activePostId, haveActivePost, titleCount: titles.length });
        if (!haveActivePost) { // active post id not in the title result
          // console.log('title of ' + wpMode + ' change and activepostid no in the title, then clear active post, active post id = ' + activePostId, { newTitles });
          dispatch(setActivePostId2(wpMode, null, null, null, null, null, titleChanged + " Title change and post not in title"));
        }
      }
    }
  }

  useEffect(() => {
    // // console.log('Wp Title Change count = ' + titles.length);
    // if (!isInFrame && wpMode == WpModes.Workplace) { // 20250716 don't set active post to nothing if run in frame, because run in frame some time direct show post id content
    //   if (activePostId) {
    //     const haveActivePost = titlesWp.some(t => t.postId == activePostId);
    //     // console.log('Title change:', { activePostId, haveActivePost, titleCount: titles.length });
    //     if (!haveActivePost) { // active post id not in the title result
    //       dispatch(setActivePostId2(wpMode, null, null, null, null, null, "Title change and post not in title"));
    //     }
    //   }
    // }
    clearActivePostOnTitleChange(WpModes.Workplace, titlesWp, "Workplace");
  }, [titlesWp]);

  useEffect(() => {
    clearActivePostOnTitleChange(WpModes.Task, titlesTk, "Task");
  }, [titlesTk]);

  useEffect(() => {
    if (titleLoading && selectedIds.size > 0) {
      setSelectedIds(new Set());
    }
  }, [titleLoading]);

  const onChangeMemberRole = async (memberRole: MemberRole) => {
    if (memberRole != activeMemberRole) {
      //dispatch(setActivePostId2(WpModes.Workplace, null, null, null, null, null, "Change member role"));
      dispatch(setActivePostId2(wpMode, null, null, null, null, null, "Change member role"));
    }
    dispatch(setActiveMemberrole(wpMode, memberRole));
    // Utils.SetMemberRoleToStorage(memberRole);
    // setSelMemberRole(memberRole);
    onClickSearch();
  }

  interface UnreadTagProps { unread: number };
  const UnreadTag: React.FC<UnreadTagProps> = ({ unread }) => {
    return (
      unread > 0 ? <>&nbsp;<span className="unread-badge p-2 me-2">{unread}</span></> : <></>
    )
  }

  const confTitle1Line = Utils.Conf_WorkPlaceTitle1Line();
  const confTitleShowLastChat = Utils.Conf_WorkPlaceTitleShowLastChat();
  // console.log({confTitle1Line, confTitleShowLastChat});

  const feeds: MemberRole[] =
    wpMode == WpModes.Workplace ? [MemberRole.All, MemberRole.Owner, MemberRole.Follower, MemberRole.TagMe, MemberRole.Flag, MemberRole.MyPost, MemberRole.Organize, MemberRole.Observer] :
      wpMode == WpModes.Task ? [MemberRole.All, MemberRole.TaskMine, MemberRole.TaskAssigner, MemberRole.TaskReqBy, MemberRole.Flag, MemberRole.TaskRelated, MemberRole.Observer]
        : [];

  const feedUnread: number[] =
    wpMode == WpModes.Workplace ? [totalUnread, roleUnread.unreadOwner, roleUnread.unreadFollower, roleUnread.unreadTagMe, roleUnread.unreadFlag, roleUnread.unreadMyPost, roleUnread.unreadOrganize + roleUnread.unreadPersonFollow, roleUnread.unreadObserver] :
      wpMode == WpModes.Task ? [totalUnread, roleUnread.taskUnreadMine, roleUnread.taskUnreadAssigner, roleUnread.taskUnreadRequestBy, roleUnread.taskUnreadFlag, roleUnread.taskUnreadRelated, roleUnread.taskUnreadObserver]
        : [];

  const [subTasks, setSubTasks] = useState<WpTitle[] | null>(null);
  const [subTaskLoading, setSubTaskLoading] = useState<boolean>(false);

  const fnLoadSubTask = async (parentTaskId: string) => {
    try {
      setSubTaskLoading(true);
      const api = new APIClient
      api.fnPostForm(urls.WP_LOAD_SUB_TASK, { parentTaskId })
        .then(rs => {
          console.log('rs:', rs);
          setSubTasks(rs);
          setSubTaskLoading(false);
        })
        .catch(e2 => {
          setSubTaskLoading(false);
          Utils.HandleException(e2, true);
        });
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const onClickTitleIn = async (e: React.MouseEvent<HTMLElement>, titleRow: WpTitle) => {
    const { postId, title: postTitle, abbrName: postAbbr, abbrFore: postFore, abbrBack: postBack, subTaskCount } = titleRow;
    if ((subTaskCount ?? 0) <= 0) {
      onClickTitle(postId, postTitle, postAbbr, postFore, postBack, titleRow);
    } else {
      const target = e.target as HTMLElement;
      const hitExpand = target.getAttribute('data-expsub') == '1';
      const isImg = target.tagName === 'IMG' && target.classList.contains("img-fluid rounded-circle img-fit img-xs");
      const isExpendIcon = target.tagName === 'SPAN' && target.classList.contains('wp-sub-task-count');
      // console.log({ tagName: target.tagName, class: target.classList, isImg, isExpendIcon });
      if (hitExpand) {
        fnLoadSubTask(postId);
        openAtCursor(e);
        setShowSubTaskDialog(prev => !prev);
        // dispatch(loadSubTask(postId));
      } else {
        onClickTitle(postId, postTitle, postAbbr, postFore, postBack, titleRow);
      }
    }
  }

  const [showSubTaskDialog, setShowSubTaskDialog] = useState<boolean>(false);
  const { ref: popRef, pos: popCur, openAtCursor } = useCursorPopup(
    showSubTaskDialog,
    () => setShowSubTaskDialog(false)
  );

  const onClickSubTask = (data: WpTitle) => {
    // 20260828 a sub-task comes from the /wp-load-sub-task popup, so it is NOT in titlesTk -
    // without this guard clearActivePostOnTitleChange wipes it on the next titlesTk change
    // (same escape hatch ApprovalList.tsx and notificationRouting.ts already use).
    Utils.SetRedirectPostId(WpModes.Task, data.postId);
    dispatch(setActivePostId2(WpModes.Task, data.postId, data.title, data.abbrName, data.abbrFore, data.abbrBack, "sub task", data));
    setShowSubTaskDialog(false);
  }

  const onCancelSelect = () => {
    setSelectedIds(new Set());
  }

  const toggleSelectId = (postId: string) => {
    setSelectedIds(prev => {
      const next = new Set(prev);
      next.has(postId) ? next.delete(postId) : next.add(postId);
      return next;
    });
  }

  const onClickAvatarSelect = (e: React.MouseEvent<HTMLElement>, postId: string) => {
    e.preventDefault();
    e.stopPropagation();
    toggleSelectId(postId);
  }

  const onMarkAsRead = () => {
    const postIdStr = Array.from(selectedIds).join('|');
    dispatch(markAsRead(wpMode, postIdStr));
    updateReadMultiApi(postIdStr).catch(e => Utils.HandleException(e, true));
    setSelectedIds(new Set());
  }

  // lazy-load the next 25 titles as the user scrolls near the bottom of the list - not offered for the
  // Task Dashboard-filtered view (titleFromTaskDashboard), whose fixed result set isn't paged on the backend
  const TITLE_SCROLL_BOTTOM_THRESHOLD = 60;
  const refTitleScroll = useRef<any>();
  const onScrollTryLoadMoreTitle = () => {
    try {
      if (titleLoadingMore || !titleHasMore || (wpMode == WpModes.Task && titleFromTaskDashboard)) return;
      const scrollableNode = refTitleScroll.current?.getScrollElement();
      if (!scrollableNode) return;
      const distanceToBottom = scrollableNode.scrollHeight - scrollableNode.scrollTop - scrollableNode.clientHeight;
      if (distanceToBottom > TITLE_SCROLL_BOTTOM_THRESHOLD) return;
      dispatch(loadMoreTitleAction(wpMode));
    } catch (e) {
      Utils.HandleException(e, false);
    }
  }

  return (
    <div className="workplace-title-ctn ">
      <div className="workplace-title-ctn-head">
        <div className="" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
          <h5 style={{ marginBottom: "0px", display: "flex", justifyContent: "space-between" }}>
            <div id="divleft">
              {/* <span className="hand" onClick={onToggleFilterPane}>{Utils.GetMemberRoleIcon(activeMemberRole)}</span> */}

              {/* <i className='fas fa-bars hand' onClick={onToggleFilterPane}></i> */}
            </div>
            <div id="divright" style={{ display: "flex", alignItems: "center" }}>
              <Dropdown isOpen={isDropdownOpen} toggle={() => setIsDropdownOpen((prev) => !prev)} >
                <DropdownToggle nav className="bg-transparent ps-1">
                  &nbsp;{(wpMode == WpModes.Task && titleFromTaskDashboard) ? "🈁จาก Dashboard" : selMemberRoleText}
                  &nbsp;<i className={isDropdownOpen ? "fas fa-chevron-up" : "fas fa-chevron-down"}></i>
                </DropdownToggle>
                <DropdownMenu>
                  {feeds.map((role, index) =>
                    <DropdownItem key={index} href="#" onClick={() => onChangeMemberRole(role)} className="d-flex justify-content-between align-items-center">
                      {Utils.GetMemberRoleIconText(wpMode, role)}
                      <UnreadTag unread={feedUnread[index]} />
                    </DropdownItem>
                  )}
                  {/* <DropdownItem href="#" onClick={() => onChangeMemberRole(MemberRole.All)} className="d-flex justify-content-between align-items-center">
                    {Utils.GetMemberRoleIconText(MemberRole.All)}
                    <UnreadTag unread={totalUnread} />
                  </DropdownItem>
                  <DropdownItem href="#" onClick={() => onChangeMemberRole(MemberRole.Owner)} className="d-flex justify-content-between align-items-center">
                    {Utils.GetMemberRoleIconText(MemberRole.Owner)}
                    <UnreadTag unread={roleUnread.unreadOwner} />
                  </DropdownItem>
                  <DropdownItem href="#" onClick={() => onChangeMemberRole(MemberRole.Follower)} className="d-flex justify-content-between align-items-center">
                    {Utils.GetMemberRoleIconText(MemberRole.Follower)}
                    <UnreadTag unread={roleUnread.unreadFollower} />
                  </DropdownItem>
                  <DropdownItem href="#" onClick={() => onChangeMemberRole(MemberRole.TagMe)} className="d-flex justify-content-between align-items-center">
                    {Utils.GetMemberRoleIconText(MemberRole.TagMe)}
                    <UnreadTag unread={roleUnread.unreadTagMe} />
                  </DropdownItem>
                  <DropdownItem href="#" onClick={() => onChangeMemberRole(MemberRole.Flag)} className="d-flex justify-content-between align-items-center">
                    {Utils.GetMemberRoleIconText(MemberRole.Flag)}
                    <UnreadTag unread={roleUnread.unreadFlag} />
                  </DropdownItem>
                  <DropdownItem href="#" onClick={() => onChangeMemberRole(MemberRole.MyPost)} className="d-flex justify-content-between align-items-center">
                    {Utils.GetMemberRoleIconText(MemberRole.MyPost)}
                    <UnreadTag unread={roleUnread.unreadMyPost} />
                  </DropdownItem>
                  <DropdownItem href="#" onClick={() => onChangeMemberRole(MemberRole.Organize)} className="d-flex justify-content-between align-items-center">
                    {Utils.GetMemberRoleIconText(MemberRole.Organize)}
                    <UnreadTag unread={roleUnread.unreadOrganize + roleUnread.unreadPersonFollow} />
                  </DropdownItem>
                  <DropdownItem href="#" onClick={() => onChangeMemberRole(MemberRole.Observer)} className="d-flex justify-content-between align-items-center">
                    {Utils.GetMemberRoleIconText(MemberRole.Observer)}
                    <UnreadTag unread={roleUnread.unreadObserver} />
                  </DropdownItem> */}

                  {/* <DropdownItem href="#" onClick={() => onChangeMemberRole(MemberRole.All)} className="d-flex justify-content-between align-items-center">
                    {Utils.GetMemberRoleIconText(MemberRole.All)}
                    <UnreadTag unread={totalUnread} />
                  </DropdownItem> */}

                </DropdownMenu>
              </Dropdown>
              {/* &nbsp;&nbsp;&nbsp;&nbsp; */}
              {/* {titleLoading ? (<LoadingIconWithText loadingText={""}></LoadingIconWithText>) : (<i className="fas fa-redo-alt hand" onClick={onClickSearch}></i>)} */}
            </div>
          </h5>
          <div className="me-3 d-flex justify-content-between align-items-center" style={{ gap: "20px" }}>
            {/* total unread count */}
            {/* {totalUnread > 0 && (
              <div className="workplace-filter-icon-bar" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setIsDropdownOpen(!isDropdownOpen); }}>
                <span className="unread-badge-wp p-2">{totalUnread}</span>
              </div>
            )} */}

            {/* total unread count of active role */}
            {totalUnreadOfRole > 0 && (
              // <div className="workplace-filter-icon-bar" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setIsDropdownOpen(!isDropdownOpen); }}>
              <div className="workplace-filter-icon-bar" onClick={(e) => { onClickUnreadIcon() }}>
                <span className="unread-badge-wp p-2">{totalUnreadOfRole}</span>
              </div>
            )}


            {/* reload workplace title */}
            <div className="workplace-filter-icon-bar">
              {titleLoading ? (<LoadingIconWithText loadingText={""}></LoadingIconWithText>) : (<i className="fas fa-redo-alt hand fz-11" onClick={onClickSearch}></i>)}
            </div>

            {/* sort order - only meaningful in Task mode, which has more than one sort option */}
            {wpMode == WpModes.Task && (
              <Dropdown isOpen={isSortDropdownOpen} toggle={() => setIsSortDropdownOpen((prev) => !prev)}>
                <DropdownToggle tag="div" className="workplace-filter-icon-bar hand" title="เรียงลำดับ">
                  <i className="fas fa-sort fz-11"></i>
                </DropdownToggle>
                <DropdownMenu end>
                  <DropdownItem active={sortMode == WpSortMode.Latest} onClick={() => onChangeSortMode(WpSortMode.Latest)} className="d-flex justify-content-between align-items-center">
                    ล่าสุด
                    {sortMode == WpSortMode.Latest && <i className="fas fa-check ms-3"></i>}
                  </DropdownItem>
                  <DropdownItem active={sortMode == WpSortMode.DueDate} onClick={() => onChangeSortMode(WpSortMode.DueDate)} className="d-flex justify-content-between align-items-center">
                    กำหนดเสร็จ
                    {sortMode == WpSortMode.DueDate && <i className="fas fa-check ms-3"></i>}
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            )}

            {/* show filter pan icon */}
            {/* <div className="workplace-filter-icon-bar hide-md-up" onClick={onToggleFilterPane}><i className="fa fa-filter"></i></div> */}
            <div className="workplace-filter-icon-bar" onClick={onToggleFilterPane}><i className="fa fa-filter fz-11"></i></div>

            {/* mark as read / cancel, shown once any title is selected via its avatar */}
            {isSelectMode && (
              <>
                <div className="workplace-filter-icon-bar hand" onClick={onMarkAsRead} title="Mark selected as read">
                  <i className="fas fa-envelope-open fz-10"></i>
                  <span className="ms-1 fz-11">{selectedIds.size}</span>
                </div>
                <div className="workplace-filter-icon-bar hand" onClick={onCancelSelect} title="Cancel">
                  <i className="fas fa-times fz-11"></i>
                </div>
              </>
            )}

          </div>
        </div>
      </div>



      <AppSimpleBar className="workplace-title-ctn-list" scrollRef={refTitleScroll} onScrollCapture={onScrollTryLoadMoreTitle}>
        {titleLoading && (<Loader />)}
        <div>
          <ul className="list-unstyled chat-list chat-user-list pe-2">
            {(wpMode == WpModes.Workplace ? titlesWp : titlesTk).map((title: WpTitle, key: number) => (
              <li
                key={key} id={title.postId}
                className={classnames({
                  active: !isSelectMode && activePostId == title.postId,
                  "wp-title-close": title.status !== WpStatus.Open,
                  "wp-title-sub": title.parentTaskId ? true : false,
                  "wp-title-selected": selectedIds.has(title.postId)
                })}
                onClick={(e) => onClickTitleIn(e, title)}
              >
                <Link to="#" className={classnames({ "unread-msg-user": title.unread })} style={{ paddingLeft: "8px", paddingRight: "10px" }}>
                  <div className="d-flex align-items-center">
                    <div
                      className={classnames("chat-user-img", confTitle1Line ? "align-self-center" : "align-self-start", "me-2", "ms-0", { "pt-0": !confTitle1Line })}
                      onClick={(e) => onClickAvatarSelect(e, title.postId)}
                      style={{ cursor: "pointer" }}
                    >
                      {
                        selectedIds.has(title.postId) ? (
                          <span className="avatar-wp-title rounded-circle bg-primary bg-opacity-10">
                            <i className="fas fa-check-square text-primary"></i>
                          </span>
                        ) : (title.icon !== null && title.icon != "") ? (
                          <span className={"avatar-wp-icon rounded-circle"} style={{ marginLeft: "-2px" }}>{title.icon}</span>
                        ) : (title.abbrName.includes('/')) ? (
                          <><img src={title.abbrName} className="img-fluid rounded-circle img-fit img-xs" onError={(e) => { (e.currentTarget as HTMLImageElement).src = '/icons/user-dummy-img.jpg'; }} /></>
                        ) : (
                          <>
                            <span className={"avatar-wp-title rounded-circle text-uppercase"} style={{ backgroundColor: title.abbrBack, color: title.abbrFore }} >
                              {title.abbrName}
                            </span>
                          </>
                        )
                      }

                      {/* {title.abbrName.includes('/')
                        ? (<img src={title.abbrName} className="img-fluid rounded-circle img-fit img-xs" />)
                        : (<span className={"avatar-wp rounded-circle text-uppercase"} style={{ backgroundColor: title.abbrBack, color: title.abbrFore }} >
                          {title.abbrName}
                        </span>)
                      } */}
                      {/* <span className={"avatar-wp rounded-circle text-uppercase"} style={{ backgroundColor: title.abbrBack, color: title.abbrFore }} >
                        {title.abbrName.includes('/')
                          ? (<><img src={title.abbrName} className="img-fluid rounded-circle img-fit img-xs" /></>)
                          : (<>{title.abbrName}</>)}
                      </span> */}
                      {/* {title.draft && (<span className="fas fa-pencil-alt wp-title-edit-pen text-red"></span>)} */}
                      {title.draft && (<span className="wp-title-edit-pen">✍️</span>)}

                      {title.status !== WpStatus.Open && (<span className="fas fa-file-archive text-danger wp-title-status-close-icon"></span>)}
                    </div>
                    <div className="overflow-hidden">
                      <p className={classnames("mb-0 wp-title", { "text-truncate": confTitle1Line })}>

                        {/* {title.title ? (<>{title.title}</>) : (<>&nbsp;</>)} */}
                        {title.title ? (<> {title.title.length > 200 ? `${title.title.slice(0, 200)}...` : title.title}</>) : (<>&nbsp;</>)}

                      </p>
                      {(wpMode == WpModes.Workplace && confTitleShowLastChat) && (
                        <p className="text-truncate mb-0 last-chat-text" style={{ paddingLeft: "2px" }}>
                          {title.lastChatImg ? (
                            <>
                              <img className="img-fluid rounded-circle img-fit img-wp-last-chat" src={title.lastChatImg ?? ""} onError={(e) => { (e.currentTarget as HTMLImageElement).src = '/icons/user-dummy-img.jpg'; }}></img>
                              <span className="lbl-wp-last-chat">{title.lastChatText}</span>
                            </>) : (
                            <>
                              <span >{title.lastChatText}</span>
                            </>)}
                        </p>
                      )}
                      {wpMode == WpModes.Task && (
                        <p className="text-truncate mb-0 last-chat-text">
                          {(!(title.isLoadingSub ?? false) && (title.subTaskCount ?? 0) > 0) && (<span data-expsub="1" className="wp-sub-task-count fas fa-list-ol"></span>)}
                          {/* {title.isLoadingSub && (<div className="wp-sub-task-count-loding"><LoadingIconWithText loadingText={""} /></div>)} */}
                          {title.approveStatus && title.approveStatus.trim() !== "" && (
                            <i className={Utils.GetDSignApproveStatusIconClass(title.approveStatus) + " me-1"} title={Utils.GetDSignApproveStatusText(title.approveStatus)}></i>
                          )}
                          <span className={`badge-task-status badge-task-status-${TaskStatus[title.taskStatus ?? TaskStatus.ToDo].toLowerCase()}`}>
                            {Utils.GetTaskStatusIcon(title.taskStatus ?? TaskStatus.ToDo)}
                            {Utils.GetTaskStatusText(title.taskStatus ?? TaskStatus.ToDo)}
                          </span>
                          {title.taskStatus !== TaskStatus.Finished && title.planFinishedDate && (
                            <span className={"ms-2 text-" + (title.isTaskOverdue ? "danger" : "warning")}>
                              Due:&nbsp;{Utils.GetDMY(title.planFinishedDate)}
                            </span>
                          )}
                          {title.taskStatus === TaskStatus.Finished /*&& title.actFinishedDate*/ && (
                            <span className={"ms-2 text-success"}>
                              On:&nbsp;{Utils.GetDMY(title.actFinishedDate)}
                            </span>
                          )}


                        </p>
                      )}
                    </div>

                    <div className="ms-auto text-end">
                      {/* {title.draft && (<span className="wp-title-edit-pen">✍️</span>)} */}
                      <p className="text-truncate mb-0 " >
                        {/* {title.flag && (<span className="fas fa-flag text-danger"></span>)} */}
                        <span className={"last-chat-time p-1 "}>{Utils.GetShortDateTimeToShowInChat(title.lastChatDate, true)}</span>
                        {title.flag && (<span className="fas fa-flag text-danger"></span>)}
                      </p>
                      <div className="d-flex justify-content-end">
                        {title.unread && title.unread > 0 ? (
                          <p className="text-truncate mb-0 unread-badge-p" >
                            <span className={"unread-badge rounded p-1 "}>{title.unread}</span>
                          </p>
                        ) : null}
                        {/* <span>⏰</span> */}
                        {title.snooze && (<i className="material-icons text-danger fz-11">snooze</i>)}
                        {/* {title.draft && (<span className="wp-title-edit-pen">✍️</span>)} */}
                      </div>
                    </div>


                    <div className="text-center " style={{ minWidth: "20px", display: "none" }} onClick={() => alert('x')}>
                      <i className="fas fa-ellipsis-v text-red"></i>
                    </div>

                  </div>
                </Link>
              </li>
            ))}
          </ul>
          {titleLoadingMore && (<div className="text-center py-2"><LoadingIconWithText loadingText={""}></LoadingIconWithText></div>)}
        </div>
      </AppSimpleBar>

      {showSubTaskDialog && (
        <div ref={popRef} className="wp-conver-content" style={{ zIndex: "9", minWidth: "200px", minHeight: "200px", maxWidth: "calc(100vw - 60px)", position: "fixed", top: popCur.y, left: popCur.x }}>
          {subTaskLoading && (<Loader />)}
          <div className="d-flex " style={{ gap: "8px", flexDirection: "column" }}>
            {!subTaskLoading && subTasks?.map((task: WpTitle, index: number) => {
              return (
                <div key={index} className="hover hand d-flex justify-content-between align-items-center" onClick={(e) => onClickSubTask(task)}>
                  <div className="d-flex align-items-center">
                    <UserAvatar profileImage={task.abbrName} abbrName="" size="xxs" />
                    {task.title}
                  </div>
                  {task.approveStatus && task.approveStatus.trim() !== "" && (
                    <i className={Utils.GetDSignApproveStatusIconClass(task.approveStatus) + " me-1"} title={Utils.GetDSignApproveStatusText(task.approveStatus)}></i>
                  )}
                  <span className={`badge-task-status badge-task-status-${TaskStatus[task.taskStatus ?? TaskStatus.ToDo].toLowerCase()}`}>
                    {Utils.GetTaskStatusIcon(task.taskStatus ?? TaskStatus.ToDo)}
                    {Utils.GetTaskStatusText(task.taskStatus ?? TaskStatus.ToDo)}
                  </span>
                </div>
              )
            })}
          </div>
        </div>
      )}

    </div >
  );
}

export default WorkplaceTitle;